import axios from '@/axios'

class ServicePackageDataService {  getAllServicePackages(): Promise<any> {
    return axios.get('/servicePackages/getAllServicePackages')
  }
  getServicePackageById(id: any): Promise<any> {
    return axios.get(`/servicePackages/${id}/get`)
  }
  add(data: any): Promise<any> {
    return axios.post(`/servicePackages/add`, data)
  }
  update(id: any, data: any): Promise<any> {
    return axios.put(`/servicePackages/${id}/update`, data)
  }
  delete(id: any): Promise<any> {
    return axios.delete(`/servicePackages/${id}/delete`)
  }
}
export default new ServicePackageDataService()